"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M15 14h1.5v1.5H15zm-3.5-7.5H13V8h-1.5z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M3 3v18h18V3zm7 2.5h4.5v6H10zm2.5 13H11V14h-1v3H8.5v-3h-1v4.5H6v-6h6.5zM18 17h-3v1.5h-1.5v-6H18z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M11.5 9H13v1.5h-1.5z"
}, "2")], 'EightMpSharp');